<div class="min-w-[320px] max-w-[560px]">
  <div class="flex items-center gap-3 px-4 pt-4">
    <mat-icon class="text-2xl" [ngClass]="{
        'text-red-500': data.config.type === 'error',
        'text-orange-500': data.config.type === 'warning',
        'text-blue-500': data.config.type === 'info'
      }">
      {{ getIcon() }}
    </mat-icon>

    <h2 mat-dialog-title class="m-0 text-lg font-semibold">
      {{ data.config.titleKey | translate }}
    </h2>
  </div>

  <mat-dialog-content class="px-4 pt-2">
    <p class="text-sm text-gray-700">
      {{ data.config.messageKey | translate }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="px-4 pb-4 pt-4">
    <button mat-button *ngIf="data.config.type !== 'error' && (data.config.actions?.length ?? 0) > 1"
      (click)="onCancel()">
      {{ 'common.cancel' | translate }}
    </button>

    <ng-container *ngFor="let action of (data.config.actions ?? [])">
      <button mat-raised-button color="primary" *ngIf="(data.config.actions?.length ?? 0) === 0" (click)="onCancel()">
        {{ 'common.ok' | translate }}
      </button>


      <ng-template #secondaryBtn>
        <button mat-button (click)="onAction(action)">
          {{ action.labelKey | translate }}
        </button>
      </ng-template>
    </ng-container>
  </mat-dialog-actions>
</div>